import React from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Table } from "@redriver/cinnamon-mui";
import { TablePanel } from "components/containers";
import { useSettings } from "components/settings";
import useFunctionDocs from "./useFunctionDocs";

const FunctionDocs = ({ entry, namespace, children }) => {
  const { apiBeforeExamples } = useSettings();
  const docs = useFunctionDocs(entry, namespace);
  if (!docs) return null;

  const { name, description, parameters, returns } = docs;
  const returnsArray = returns ? [returns] : null;

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        {name}
      </Typography>
      <Typography>{description}</Typography>
      {!apiBeforeExamples && children}
      {parameters && (
        <TablePanel sx={{ mt: 4 }}>
          <Table data={parameters} dataKey="name">
            <Table.Column field="name" title="Parameters" width="25%" />
            <Table.Column field="type" title="Type" width="25%" />
            <Table.Column field="description" title="Description" width="50%" />
          </Table>
        </TablePanel>
      )}
      <TablePanel sx={{ mt: 4 }}>
        <Table data={returnsArray} dataKey="type">
          <Table.Column field="type" title="Returns" width="50%" />
          <Table.Column field="description" title="Description" width="50%" />
        </Table>
      </TablePanel>
      {apiBeforeExamples && children}
      {process.env.NODE_ENV === "development" && (
        <Accordion disableGutters sx={{ mt: 4 }}>
          <AccordionSummary>View Typedoc Data</AccordionSummary>
          <AccordionDetails>
            <pre>{JSON.stringify(docs, null, 2)}</pre>
          </AccordionDetails>
        </Accordion>
      )}
    </React.Fragment>
  );
};

export default FunctionDocs;
